import { motion } from "framer-motion";
import { COIN_IMG, NARRATIVE, NARRATIVE_CLOSER, NARRATIVE_PULL, NARRATIVE_TAGLINE, NARRATIVE_TITLE } from "@/data";

const EASE = [0.22, 1, 0.36, 1];
const reveal = {
  initial: { opacity: 0, y: 34 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.85, ease: EASE },
};

export default function NarrativeManifesto() {
  return (
    <section id="narrative" className="relative py-28 sm:py-36" data-testid="narrative-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[280px_1fr] lg:gap-20">
        {/* Sticky rail */}
        <div className="lg:sticky lg:top-28 lg:self-start">
          <motion.p {...reveal} className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#E5A93C]">
            01 / The Narrative
          </motion.p>
          <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.1 }} className="mt-8 hidden lg:block">
            <div className="relative h-28 w-28">
              <div className="absolute inset-0 rounded-full border border-dashed border-[rgba(229,169,60,0.5)]" style={{ animation: "spin-slow 24s linear infinite" }} />
              <img src={COIN_IMG} alt="" className="absolute inset-2 rounded-full object-cover" />
            </div>
            <p className="mt-5 font-mono2 text-[10px] uppercase leading-relaxed tracking-[0.25em] text-[#64748B]">
              Official seal of the
              <br />
              meme movement
            </p>
          </motion.div>
        </div>

        {/* Manifesto body */}
        <div>
          <motion.h2
            {...reveal}
            className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-[#F8FAFC] sm:text-3xl lg:text-4xl"
            data-testid="narrative-title"
          >
            {NARRATIVE_TITLE}
          </motion.h2>

          <div className="mt-12 space-y-8">
            {NARRATIVE.map((p, i) => (
              <motion.p
                key={i}
                {...reveal}
                transition={{ ...reveal.transition, delay: i * 0.06 }}
                className={`max-w-3xl text-base leading-[1.85] text-[#94A3B8] sm:text-lg ${
                  i === 0 ? "drop-cap" : ""
                }`}
              >
                {p}
              </motion.p>
            ))}
          </div>

          {/* Pull quote */}
          <motion.blockquote
            {...reveal}
            className="relative my-16 border-l-2 border-[#E5A93C] py-2 pl-8 sm:pl-12"
            data-testid="narrative-pull-quote"
          >
            <span className="absolute -left-1 -top-7 font-display text-8xl font-black text-[rgba(229,169,60,0.25)]">
              &ldquo;
            </span>
            <p className="font-display text-2xl font-bold leading-snug text-[#F8FAFC] sm:text-3xl lg:text-[2.6rem] lg:leading-[1.15]">
              In the memecoin world,{" "}
              <span className="text-[#E5A93C]">attention starts the fire</span> — but{" "}
              <span className="text-[#E5A93C]">community is what keeps it burning.</span>
            </p>
            <cite className="mt-5 block font-mono2 text-[11px] uppercase not-italic tracking-[0.3em] text-[#64748B]">
              {NARRATIVE_PULL}
            </cite>
          </motion.blockquote>

          <motion.div {...reveal} className="border-t border-[rgba(229,169,60,0.18)] pt-12">
            <p className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-testid="narrative-closer">
              {NARRATIVE_CLOSER}
            </p>
            <p className="mt-6 font-mono2 text-sm uppercase tracking-[0.3em] text-[#E5A93C]" data-testid="narrative-tagline">
              {NARRATIVE_TAGLINE}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
